import React, { useState, useEffect } from "react";
import { changeSelectedTime } from "../../store/slice/orderSlice";
import { useDispatch, useSelector } from "react-redux";
import { getMasterAvailability } from "../../api";

const TimePicker = () => {
  const [times, setTimes] = useState([]);
  const { selectedStudio, selectedMaster, selectedDate, selectedTime, selectedService } = useSelector(
    (state) => state.orderReducer
  );
  const dispatch = useDispatch();

  useEffect(() => {
    getFreeTime();
  }, [selectedDate]);

  const getFreeTime = async () => {
    if (selectedStudio?.id && selectedMaster?.id) {
      const freeTimes = await getMasterAvailability({
        studioId: selectedStudio.id,
        masterId: selectedMaster.id,
        date: selectedDate ? selectedDate : Date.now(),
      });

      setTimes(convertFreeTimes(freeTimes.data?.availability));
    }
  };

  const convertFreeTimes = (times) => {
    const convertedTime = [];
    if (times && times.length) {
      times.map((time) => {
        const slotDuration = (time.to.hours - time.from.hours) * 60 - time.from.minutes + time.from.minutes;

        if (slotDuration >= selectedService.duration) {
          let hours = time.from.hours;
          let minutes = time.from.minutes;
          const endHours = time.to.hours - Math.trunc(selectedService.duration / 60);
          const endMinutes = selectedService.duration % 60;

          convertedTime.push({ hours: hours, minutes: minutes });
          while (!(hours >= endHours && minutes >= endMinutes)) {
            minutes += 15;
            if (minutes >= 60) {
              hours++;
              minutes = 0;
            }
            convertedTime.push({ hours: hours, minutes: minutes });
          }
        }
      });
    }

    return convertedTime;
  };

  const setSelectedTime = (time) => {
    return () => dispatch(changeSelectedTime(time));
  };

  return (
    <div className="time-picker">
      <div className="time-list__wrapper">
        <div className="time-list__title">Time for the appointment</div>
        <div className="scroll-item">
          {!!times?.length ? (
            <div className="time-list">
              {times.map((item, i) => (
                <div
                  className={selectedTime === item ? "time-list__item selected" : "time-list__item"}
                  key={i}
                  onClick={setSelectedTime(item)}
                >
                  {`${item.hours} :  ${item.minutes === 0 ? "00" : item.minutes}`}
                </div>
              ))}
            </div>
          ) : selectedMaster ? (
            <p>No free places</p>
          ) : (
            <p>Please select a master</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default TimePicker;
